import { render, staticRenderFns } from "./CanvasHandwrite.vue?vue&type=template&id=5fc85cae&scoped=true&"
import script from "./CanvasHandwrite.vue?vue&type=script&lang=js&"
export * from "./CanvasHandwrite.vue?vue&type=script&lang=js&"
import style0 from "./CanvasHandwrite.vue?vue&type=style&index=0&id=5fc85cae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc85cae",
  null
  
)

export default component.exports